import { TextField, InputAdornment } from "@mui/material";
import styles from "./GlobalFilter.module.css";
import SearchIcon from "@mui/icons-material/Search";
import React, { useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";

interface IGlobalFilter {
  preGlobalFilteredRows: any;
  globalFilter: any;
  setGlobalFilter: any;
}

// Define a default UI for filtering
export const GlobalFilter: React.FC<IGlobalFilter> = (props) => {
  const { setGlobalFilter, globalFilter } = props;
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();
  const onChange = useCallback((value: string) => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setGlobalFilter(value || undefined);
    }, 200);
  }, [setGlobalFilter]);

  const [filterValueState, setFilterValueState] = useState("");

  useEffect(() => {
    setFilterValueState(globalFilter ?? "");
  }, [globalFilter])
  
  return (
    <TextField
      classes={{
        root: classNames(styles.input, styles.inline, styles.searchRoot),
      }}
      InputProps={{
        className: classNames(styles.input, styles.widthSearch),
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon fontSize={"small"} />
          </InputAdornment>
        ),
      }}
      type={"text"}
      placeholder="Search"
      value={filterValueState}
      fullWidth
      label=""
      variant="outlined"
      name="search"
      onChange={(e: any) => {
        const value = e.target.value as string;
        setFilterValueState(value);
        onChange(value.trim());
      }}
    />
  );
};
